import { useMemo } from "react";
import { useCurrentUser } from "./useCurrentUser";
import { Company } from "../types/company";
import { Manager } from "../types/users";

export const useCompany = (): Company | null => {
  const user = useCurrentUser();

  return useMemo(() => {
    // Check if user is a Manager and has company property
    if (user && "company" in user) {
      return (user as Manager).company || null;
    }
    return null;
  }, [user]);
};

